import { FC } from "react";
import { Outlet } from "react-router-dom";
import "./Layout.scoped.scss";
const Layout: FC = () => {
    return (
        <div className="layout">
            <Outlet />
            <div className="footer">
                <div className="container">
                    <div className="left">
                        <img src={require("~@/assets/logo.png")} alt="" />
                    </div>
                    {/* <div className="mid">
                        <div className="name">推广渠道</div>
                        <img
                            className="qrcodes"
                            src={require("~@/assets/qrcodes.png")}
                            alt=""
                        />
                    </div>
                    <div className="right">
                        <div className="name">相关信息</div>
                        <a href="">关于我们</a>
                        <a href="">版权声明</a>
                        <a href="">友情链接</a>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default Layout;
